import { Box } from "@mui/material";
import React from "react";

export default function EmptyAddContent({
  buttonText = "Create New",
  onClick,
  sx,
  ...props
}) {
  return (
    <Box
      border="1px dashed #7B61FF"
      color="#7B61FF"
      borderRadius="4px"
      width="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="280px"
      sx={{ cursor: "pointer" }}
      onClick={onClick}
      {...sx}
      {...props}
    >
      <i className="meta-crm-icon-ic_add font-size-16" />
      <Box ml="4px" fontSize={"12px"} fontWeight={700}>
        {buttonText}
      </Box>
    </Box>
  );
}
